import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {Standard} from 'app/models/standard.model';
import {standardResponseWithVersion} from 'app/services/standard-version';
import {HttpResponse} from '@angular/common/http';
import {StandardUserRemoval} from 'app/services/standard-user-removal';
import {StandardFamiliarizationUser} from 'app/models/standard-user.model';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {StepTestingService} from '../opst-step-six/step-create-testing/step-testing.service';
import * as moment from 'moment';
import {UserService} from '../../../../services/user.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {StepConfirmPopupComponent} from '../step-confirm-popup/step-confirm-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../services/admin.service';
import {ViewDocxService} from '../../../../services/view-docx.service';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';

@Component({
  selector: 'app-opst-step-seven',
  templateUrl: './opst-step-seven.component.html',
  styleUrls: ['./opst-step-seven.component.css']
})
export class OpstStepSevenComponent implements OnInit, OnDestroy {
  userRemoval = new StandardUserRemoval(this.adminService, this.modalService);

  showTestingStart = false;
  thisStandard: any;
  usersAndGroups: any;
  stringDate: string;
  daysForTesting = 5;
  daysForTestingTemp = null;
  showTestingBtn = false;
  goToSeven = false;
  showTable = false;
  isReadOnly = false;
  goBtnIsClicked = false;
  isLoaded = false;
  isLoadedStep = false;
  tableUsers: any;
  changeLogs: any[];
  showAddUser = false;
  showUserFTable = true;
  showChangeLog = false;
  showFilesAndBlanks = true;

  constructor(public stepsControllerService: StepsControllerService,
              public stepTestingService: StepTestingService,
              private modalService: NgbModal,
              public viewDocxService: ViewDocxService,
              private apiConnectService: ApiConnectService,
              private userService: UserService,
              private adminService: AdminService) {
  }

  ngOnInit() {
    this.isLoadedStep = false;
    this.stringDate = moment().format('DD.MM.YYYY');
    this.thisStandard = this.stepsControllerService.getCurrentStandard();

    if (this.thisStandard.status === 'ACTIVE') {
      this.showTestingStart = true;
    }

    if (this.stepsControllerService.getCurrentStandard().readyForTestingStage) {
      this.goToSeven = true;
      this.showTestingBtn = true;
    } else {
      this.goToSeven = false;
      this.showTestingBtn = false;

      if (!this.stepsControllerService.getCurrentStandard().readyForTestingStage &&
        !this.stepsControllerService.getCurrentStandard().readyForFamiliarizationStage &&
        !this.stepsControllerService.getCurrentStandard().needModifications) {
        this.stepsControllerService.stepSevenDisabled = false;
      }

    }

    if (this.thisStandard.readyForTestingStage && this.thisStandard.status === 'UNDER_FAMILIARIZATION') {
      this.showTestingBtn = true;
      this.isReadOnly = false;
    }

    this.getUserTable();
  }

  getUserTable() {
    this.isLoaded = false;
    this.isLoadedStep = false;
    // Get familiarize info:
    this.stepsControllerService.getFamiliarizedInfo(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tableUsers = response.body;
          this.isLoaded = true;
          this.isLoadedStep = true;
          this.thisStandard.status = this.stepsControllerService.getCurrentStandard().status.toString();

          if (this.tableUsers.length > 0) {
            this.showTable = true;
          } else {
            this.showTable = false;
          }
        }
      },
      () => {
        this.isLoaded = true;
        this.isLoadedStep = true;
      }
    );
  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  deleteFileDOCX(sid, fileLink, type) {
    this.adminService.deleteTempDocxFileManually(fileLink, sid).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.thisStandard.ruDoc = null;
          this.thisStandard.ruFileLink = null;
        } else if (type === 'EN_DOC') {
          this.thisStandard.enDoc = null;
          this.thisStandard.enFileLink = null;
        }
      },
      () => {
      }
    );
  }


  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );

  }

  userReloadFailed = false;
  private usersDestroyed$ = new Subject<void>();

  ngOnDestroy(): void {
    this.userRemoval.ngOnDestroy();
    this.usersDestroyed$.next();
    this.usersDestroyed$.complete();
  }

  reloadStandardUsers(): void {
    if (this.userRemoval.pending) { return; }
    this.userRemoval.pending = true;
    this.userReloadFailed = false;
    this.adminService.getStandard(this.thisStandard.id).takeUntil(this.usersDestroyed$).subscribe(
      (response: HttpResponse<Standard>) => {
        this.userRemoval.pending = false;
        const standard = standardResponseWithVersion(response).body;
        if (!standard || standard.id !== this.thisStandard.id) { this.userReloadFailed = true; return; }
        this.userRemoval.reset();
        this.stepsControllerService.setCurrentStandard(standard);
      }, () => { this.userRemoval.pending = false; this.userReloadFailed = true; }
    );
  }
  deleteUserFromStnd(user: StandardFamiliarizationUser): void {
    this.userRemoval.remove(this.thisStandard, user, users => this.acceptAssignedUsers(users));
  }

  acceptAssignedUsers(users: StandardFamiliarizationUser[]): void {
    this.tableUsers = users;
    this.showTable = !!users.length;
  }

  shBlock(s) {
    switch (s) {
      case 'sau':
        this.showAddUser = !this.showAddUser;
        break;
      case 'stou':
        this.showUserFTable = !this.showUserFTable;
        break;
      case 'scl':
        this.showChangeLog = !this.showChangeLog;
        break;
      case 'sfab':
        this.showFilesAndBlanks = !this.showFilesAndBlanks;
        break;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-seven/opst-step-seven.component.ts